import { render, staticRenderFns } from "./StudentsMessage.vue?vue&type=template&id=1a969313&"
import script from "./studentsmessage.js?vue&type=script&lang=js&"
export * from "./studentsmessage.js?vue&type=script&lang=js&"
import style0 from "./StudentsMessage.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports